export default {
  props: {
    hex: {
      type: String
    }
  }
};